
class VisitNotesController {
  constructor($log, $scope, Orders, Users, Notifications, toastr, Auth, $rootScope) {
    'ngInject';

    angular.extend(this, {
      $log,
      $scope,
      $rootScope,
      Notifications,
      toastr,
      Orders,
      Users,
      currentUser: Auth.profile,
      titles: ['Rejected Reason:', 'Rejected By:', 'Not Treated Reason:', 'Evaluating Clinician:', 'Visit'],
      pagination: {
        limit: 10
      },
      notes: [],
      patient: $scope.ngDialogData.patient,
      visit: $scope.ngDialogData.visit
    });

    $scope.$on('ngDialog.opened', this.initChatbox.bind(this)); // When to reload notes

    $scope.$on('visit:updated', () => this.loadNewer());
    $scope.$on('visit:denied', () => this.loadNewer());
    $scope.$on('visit:load', () => this.loadNewer());
    $scope.$on('visit:completed', () => this.loadNewer());
    this.loadOlder();
  }
  /**
   * Determines if older notes exist
   */

  $onInit() {
    this.loadOlder();
  }


  hasMoreNotes() {
    return this.pagination.total > this.notes.length;
  }
  /**
   * Loads newer notes
   */


  loadNewer() {
    const newerPagination = {};

    if (this.pagination.cursors) {
      const {
        after
      } = this.pagination.cursors;
      newerPagination.after = after;
    }

    this.getNotes(newerPagination).then(({
      notes,
      pagination
    }) => {
      Object.assign(this.pagination, {
        after: pagination.cursors && pagination.cursors.after,
        total: pagination.total
      });
      this.notes.unshift(...notes);
    });
  }
  /**
   * Loads previous notes
   */


  loadOlder() {
    const olderPagination = {}; //console.log(this.pagination);

    if (this.pagination.cursors) {
      const {
        before
      } = this.pagination.cursors;
      olderPagination.before = before;
    }

    this.getNotes(olderPagination).then(({
      notes,
      pagination
    }) => {
      Object.assign(this.pagination, {
        before: pagination.cursors && pagination.cursors.before,
        total: pagination.total
      });
      this.notes.push(...notes);
    }).catch(err => this.$log.log(err));
  }
  /**
   * Loads, formats and passes on notes on to next thennable statement
   * Will not append notes to view
   */


  getNotes(query) {
    this.loading = true;
    return this.Users.getNotes(this.patient.id, query).then(({
      data
    }) => {
      let {
        data: notes,
        pagination
      } = data;
      Object.assign(this.pagination, pagination);
      notes = this.formatNotes(notes);
      return {
        notes,
        pagination
      };
    }).catch(err => this.$log.log(err)).finally(() => {
      this.loading = false;
    });
  }

  post() {
    this.posting = true;
    this.Orders.postNote(this.note).then(() => {
      this.note = '';
      this.showForm = false;
      this.$rootScope.$broadcast('visit-notes:refresh');
      this.loadNewer();
      this.scrollChatbox();
    }).catch(err => {
      if (err.status === 403) {
        this.toastr.error(this.Notifications.orders.locked);
      }
    }).finally(() => {
      this.posting = false;
    });
  }

  initChatbox() {
    this.chatBox = $('.chat-modal .ngdialog-content').draggable({
      // handle: '.dialog-header',
      handle: '.visit-notes-handler',
      scroll: false
    }).resizable({
      containment: 'parent',
      handles: 'se'
    });
  }

  scrollChatbox() {
    this.$timeout(() => {
      angular.element('.chat-box').stop().animate({
        scrollTop: 0
      });
    });
  }
  /**
   * Boldens rejection notes without having to format from backend
   */


  formatNotes(notes) {
    notes.forEach(note => {
      this.titles.forEach(title => {
        const startPos = note.text.indexOf(title);

        if (startPos > -1) {
          const template = `${startPos > 0 ? '<span class="block"></span>' : ''}<strong>${title}</strong>`;
          note.text = note.text.replace(/,/gi, '').splice(startPos, title.length, template);
        }
      });
    });
    return notes;
  }

}

VisitNotesController.$inject = ["$log", "$scope", "Orders", "Users", "Notifications", "toastr", "Auth", "$rootScope"];
angular.module('pims').controller('VisitNotesController', VisitNotesController);

